import React, { useMemo } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns } from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false;

const Table2 = ({ data, reactVerbosity }) => {
  // console.log('Table2 RENDERING');
  data.forEach((s, i) => {
    // const userScoreStr = `${s.userScore}/${s.maxScore}`;
    // data[i].userScore = userScoreStr;
    let userScoreStr = '';
    if (typeof s.userScore === 'string' && s.userScore.includes('/')) {
      const userScoreArr = s.userScore && s.userScore.split('/');
      // userScoreStr = `${userScoreArr[0]}/${s.maxScore}`;
      userScoreStr = ((parseInt(userScoreArr[0])/s.maxScore) * 100).toFixed();
      userScoreStr = `${userScoreStr}%`;
    } else {
      // userScoreStr = `${s.userScore}/${s.maxScore}`;
      userScoreStr = ((s.userScore/s.maxScore) * 100).toFixed();
      userScoreStr = `${userScoreStr}%`;
    }
    data[i].userScoreNew = userScoreStr;
  });
  reactVerbosity === 2 &&
    console.log('###################> TABLE2b DATA:', data);
  const columns = useMemo(() => [
    {
      accessorKey: 'negotiation', // access nested data with dot notation
      header: 'Negotiation',
      size: 250,
    },
    {
      accessorKey: 'user', // access nested data with dot notation
      header: 'Trainee'
    },
    {
      accessorKey: 'userScoreNew',
      header: 'Score'
    },
    // {
    //   accessorKey: 'maxScore',
    //   header: 'MaxScore',
    // },
    {
      accessorKey: 'moduleCountByType',
      header: 'Attempts'
    },
    {
      accessorKey: 'date',
      header: 'Date of Top Score'
    }
    // {
    //   accessorKey: 'moduleCount',
    //   header: 'Attempts',
    // }
  ]);
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    initialState: {
      density: 'xs',
      expanded: true,
      pagination: { pageIndex: 0, pageSize: 20 }
    },
    mantineTableContainerProps: { 
      sx: { 
        height: '64%',
        maxHeight: 'calc(80vh * 0.8)',
        paddingLeft: '16px',  // Add left padding
        paddingRight: '16px', // Add right padding
      } 
    },
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnDragging: false,
    mantineTopToolbarProps: {
      sx: {
        backgroundColor: 'white',
        borderRadius: '8px 8px 0 0',
        ppaddingTop: '0px',
        marginTop: '8px',
        marginBottom: '0px',
      },
    },
    mantineTableProps: {
      sx: {
        borderRadius: '8px 8px 0 0',
      },
    },
    mantineToolbarAlertBannerProps: {
      color: 'blue',
    },
    positionToolbarAlertBanner: 'bottom',
    mantinePaperProps: {
      sx: {
        '& .mantine-ActionIcon-root': {
          backgroundColor: '#e9ecef !important',
          borderRadius: '8px !important',
          margin: '0 4px',
          width: '32px !important',
          height: '32px !important',
          '&:hover': {
            backgroundColor: '#dee2e6 !important',
          },
          '& svg': {
            width: '16px !important',
            height: '16px !important',
          },
        },
        '& .mantine-TableFooter-root': {
          backgroundColor: '#e9ecef !important',
        },
        '& .mantine-TableFooter-root td': {
          fontWeight: 'bold !important',
          color: '#333 !important',
          padding: '12px 16px !important',
        },
        '& .mantine-Table-root + div': {
          backgroundColor: '#e9ecef !important',
          padding: '8px 16px',
        },
      },
    },
    mantineTableHeadCellProps: {
      sx: {
        backgroundColor: '#e9ecef',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: '#333',
        padding: '8px 6px',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        padding: '8px 6px', // Adjust padding for body cells
      },
    },
    icons: {
      IconColumns: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="18px"
          height="18px"
        >
          <path d="M0 0h24v24H0z" fill="none"/>
          <circle cx="3.5" cy="7" r="1.5"/>
          <rect x="8" y="6" width="13" height="2"/>
          <circle cx="3.5" cy="12" r="1.5"/>
          <rect x="8" y="11" width="13" height="2"/>
          <circle cx="3.5" cy="17" r="1.5"/>
          <rect x="8" y="16" width="13" height="2"/>
        </svg>
      ),
      IconFilter: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
      ),
      IconSearch: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      )
    },
    mantineBottomToolbarProps: {
      sx: {
        backgroundColor: '#e9ecef !important',
        borderRadius: '0 0 8px 8px', // Add border radius to bottom corners
        margin: '8px 16px', // Match the side padding
      },
    },
  });

  return <MantineReactTable table={table} />;
};

export default React.memo(Table2);

// mantineTableBodyRowProps={{
//   sx: {
//     height: '10px'
//   }
// }} mantineTableBodyCellProps={{
//   sx: {
//     padding: '2px 16px'
//   }
// }}
// mantinePaperProps={{
//   shadow: 'xs'
// }}
